import WizardCard from '../morning/WizardCard.jsx';

// Step 1: For each of today's 3 MITs, ask if it was completed. If not,
// ask why (free text). Reuses the daily_checkout fields the Full Dash
// checkboxes already write to.
export default function StepMITReview({
  briefing,
  checkout,
  onUpdate,
  onNext,
}) {
  const slots = [1, 2, 3].map((i) => ({
    slot: i,
    text: briefing?.[`mit_${i}_text`] || `(MIT ${i} not set)`,
    done: checkout?.[`mit_${i}_done`],
    reason: checkout?.[`mit_${i}_reason`] || '',
  }));

  function setDone(slot, done) {
    const patch = { [`mit_${slot}_done`]: done };
    if (done) patch[`mit_${slot}_reason`] = null;
    onUpdate(patch);
  }

  function setReason(slot, reason) {
    onUpdate({ [`mit_${slot}_reason`]: reason });
  }

  // Each slot is "answered" when either done=true OR (done=false AND reason has text).
  // Allow proceeding once every slot has been answered.
  const allAnswered = slots.every(
    (s) => s.done === true || (s.done === false && s.reason.trim().length > 0)
  );

  return (
    <WizardCard
      step={1}
      totalSteps={4}
      title="How did the day go?"
      subtitle="For each MIT, did you complete it?"
      onNext={onNext}
      hideBack
      nextDisabled={!allAnswered}
    >
      <div className="space-y-4">
        {slots.map((s) => (
          <div key={s.slot} className="border border-border-base rounded p-3">
            <div className="text-sm text-text-primary mb-2">
              <span className="text-text-muted mr-1">{s.slot}.</span> {s.text}
            </div>
            <div className="flex gap-2 mb-2">
              <Choice
                label="Done"
                active={s.done === true}
                onClick={() => setDone(s.slot, true)}
              />
              <Choice
                label="Not done"
                active={s.done === false}
                onClick={() => setDone(s.slot, false)}
              />
            </div>
            {s.done === false && (
              <input
                type="text"
                value={s.reason}
                onChange={(e) => setReason(s.slot, e.target.value)}
                onBlur={(e) => setReason(s.slot, e.target.value)}
                placeholder="Why not? (one line)"
                className="w-full text-sm bg-bg-input border border-border-base rounded px-2 py-1.5 text-text-primary focus:outline-none focus:border-accent-blue"
              />
            )}
          </div>
        ))}
      </div>
    </WizardCard>
  );
}

function Choice({ label, active, onClick }) {
  return (
    <button
      onClick={onClick}
      className={`flex-1 py-1.5 text-sm font-medium rounded border transition ${
        active
          ? 'bg-accent-blue text-white border-accent-blue'
          : 'bg-bg-input text-text-primary border-border-base hover:border-accent-blue/40'
      }`}
    >
      {label}
    </button>
  );
}
